export default __webpack_public_path__ + "static/media/ooo3.6b06c374.gif";